// extracted by mini-css-extract-plugin
export default {"products":"Products_products__poCIR","tables":"Products_tables__LFwHU","table":"Products_table__CeQqc"};